module.exports = "/_next/static/images/promote-financial-responsibility-8e5266ccd359ad7f55132050d16b228a.svg";